import { stringSchema, objectSchema, recordSchema, booleanSchema } from '@/schemas'

export const userProfileSchema = objectSchema({
  name: stringSchema.min(1, 'Name must be at least 1 characters').max(100, 'Name must be at most 100 characters'),
  notification_preferences: recordSchema(booleanSchema),
})
